import {AppBar, IconButton, Link, ListItemIcon, ListItemText, Menu, MenuItem, Toolbar} from "@mui/material";
import {Call, Edit, Home, Info, Menu as MenuIcon, Message, Visibility} from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router";
import route from "../../../../enum/route";
import database from "../../../../database/database";
import useEventDispatcher from "../../../../use/useEventDispatcher";
import useSecurity from "../../../../use/useSecurity";
import role from "../../../../enum/role";
import useQualityInspectionRepository from "../../../../repository/emergency/useQualityInspectionRepository";
import QualityInspectionUtils from "../../../../entity/utils/emergency/QualityInspectionUtils";
import QualityInspection from "../../../../entity/emergency/QualityInspection";
import useClientRepository from "../../../../repository/emergency/useClientRepository";
import Notification from "../../entrepreneur/Notification";
import useInterventionRepository from "../../../../repository/emergency/useInterventionRepository";
import isNull from "../../../../mixin/isNull";

export default function ({
                             orderId,
                             qualityInspectionId,
                             clientId,
                             onLetMessageClicked,
                             onUpdateQuotation,
                             updateQuotation,
                             onOpenClientPriceCertificate,
                             onOpenOrderData
                         }) {
    const {token} = useParams();
    const security = useSecurity();
    const eventDispatcher = useEventDispatcher();
    const navigate = useNavigate();
    const interventionRepository = useInterventionRepository();
    const qualityInspectionRepository = useQualityInspectionRepository();
    const clientRepository = useClientRepository();
    /** @type Intervention */
    const intervention = interventionRepository.findOneByToken(token).select();
    /** @type QualityInspection */
    const qualityInspection = qualityInspectionRepository.findOneById(qualityInspectionId).select();
    /** @type Client */
    const client = clientRepository.findOneById(clientId).select();
    const [anchorEl, setAnchorEl] = useState(null);

    useEffect(() => {
        interventionRepository.findOneByToken(token).exec();
        clientRepository.findOneById(clientId).exec();
    }, []);

    const handleMenu = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleHome = () => {
        navigate(route.ENTREPRENEUR_INTERVENTIONS);
        handleClose();
    }

    const handleTheme = theme => () => {
        eventDispatcher.launcher("toggle-mode", {
            mode: theme
        });
        handleClose();
    }

    const handleOpenCompanySpace = () => {
        window.open(`${process.env.REACT_APP_COMPANY_SPACE_URL}#access_token=${database.read(database.TABLE_AUTHENTICATION, "access_token")}`, "_blank", "location=yes");
        handleClose();
    }

    const handleLetMessage = () => {
        onLetMessageClicked();
        handleClose();
    }

    const handleOpenOrderData = () => {
        onOpenOrderData();
        handleClose();
    }

    const handleUpdateQuotation = () => {
        onUpdateQuotation();
        handleClose();
    }

    const handleOpenClientPriceCertificate = () => {
        onOpenClientPriceCertificate();
        handleClose();
    }

    if (isNull(qualityInspection) || isNull(intervention)) return null;

    return (
        <AppBar position="sticky" sx={{top: 0}}>
            <Toolbar>
                <Typography
                    component="div"
                    sx={{flexGrow: 1, textTransform: "uppercase"}}
                    fontWeight={"bold"}
                    data-test="header-text"
                >
                    Dossier {orderId}
                    <Typography fontSize="small">
                        {updateQuotation ? "Modification du devis" : QualityInspectionUtils.getCurrentStepAsTextForCompany(qualityInspection.getCurrentStep(), qualityInspection.getCurrentSubStep())}
                    </Typography>
                </Typography>
                <div>
                    {security.roles.includes(role.ENTREPRENEUR) && <Notification/>}
                    <IconButton
                        size="large"
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleMenu}
                        color="inherit"
                        data-test="button-menu"
                    >
                        <MenuIcon/>
                    </IconButton>
                    <Menu
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={handleLetMessage} data-test="menu-let-message">
                            <ListItemIcon>
                                <Message/>
                            </ListItemIcon>
                            <ListItemText>
                                Nous laisser un message
                            </ListItemText>
                        </MenuItem>
                        {
                            qualityInspection.getCurrentStep() > QualityInspection.STEP_INITIALIZED
                                ? (
                                    <MenuItem onClick={handleClose} data-test="menu-call-beneficiary">
                                        <ListItemIcon>
                                            <Call/>
                                        </ListItemIcon>
                                        <ListItemText>
                                            <Link
                                                href={`tel:${client?.getPhone1()}`}
                                                sx={{textDecoration: "none", color: "inherit"}}
                                            >
                                                Appeler le sociétaire
                                            </Link>
                                        </ListItemText>
                                    </MenuItem>
                                )
                                : null
                        }
                        <MenuItem onClick={handleOpenOrderData}>
                            <ListItemIcon>
                                <Info/>
                            </ListItemIcon>
                            <ListItemText>
                                Info dossier
                            </ListItemText>
                        </MenuItem>
                        {
                            qualityInspection.getCurrentStep() === QualityInspection.STEP_QUOTATION
                            || qualityInspection.getCurrentStep() === QualityInspection.STEP_CLIENT_SIGNATURE
                                ? (
                                    <MenuItem onClick={handleUpdateQuotation} data-test="menu-modify-quotation">
                                        <ListItemIcon>
                                            <Edit/>
                                        </ListItemIcon>
                                        <ListItemText>
                                            Modifier mon devis
                                        </ListItemText>
                                    </MenuItem>
                                )
                                : null
                        }
                        {
                            qualityInspection.getCurrentStep() > QualityInspection.STEP_QUOTATION
                            && intervention.getClientPrice() > 0
                                ? (
                                    <MenuItem onClick={handleOpenClientPriceCertificate}
                                              data-test="menu-open-certificate-delivery"
                                    >
                                        <ListItemIcon>
                                            <Visibility/>
                                        </ListItemIcon>
                                        <ListItemText>
                                            Afficher le devis
                                        </ListItemText>
                                    </MenuItem>
                                )
                                : null
                        }
                        <MenuItem onClick={handleClose}>
                            <ListItemIcon>
                                <Call/>
                            </ListItemIcon>
                            <ListItemText>
                                <Link
                                    href={`tel:${process.env.REACT_APP_FFG_PHONE_NUMBER}`}
                                    sx={{textDecoration: "none", color: "inherit"}}
                                >
                                    Nous contacter
                                </Link>
                            </ListItemText>
                        </MenuItem>
                        <MenuItem onClick={handleHome} data-test="menu-back">
                            <ListItemIcon>
                                <Home/>
                            </ListItemIcon>
                            <ListItemText>
                                Revenir à l'accueil
                            </ListItemText>
                        </MenuItem>
                        {
                            /**
                             <MenuItem
                             disabled={!security.roles.includes(role.ENTREPRENEUR)}
                             onClick={handleOpenCompanySpace}
                             >
                             <ListItemIcon>
                             <AccountBox/>
                             </ListItemIcon>
                             <ListItemText>
                             Mon espace
                             </ListItemText>
                             </MenuItem>
                             */
                        }

                        {
                            /**
                             {
                             !isNull(database.read(database.TABLE_THEME, "dark"))
                             && database.read(database.TABLE_THEME, "dark") === "dark"
                             ? <MenuItem onClick={handleTheme("light")}>
                             <ListItemIcon>
                             <LightMode/>
                             </ListItemIcon>
                             <ListItemText>
                             Theme blanc
                             </ListItemText>
                             </MenuItem>
                             : <MenuItem onClick={handleTheme("dark")}>
                             <ListItemIcon>
                             <DarkMode/>
                             </ListItemIcon>
                             <ListItemText>
                             Theme sombre
                             </ListItemText>
                             </MenuItem>
                             }
                             */
                        }

                    </Menu>
                </div>
            </Toolbar>
        </AppBar>
    );
}